export const authSelector = (state) => ({
  auth: state.auth
});
